import { useState } from "react";
import { afrostalgiaimgs } from "../data/galleryimgdata";

const Afrostalgia = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openImage = (index) => {
    setCurrentIndex(index);
    setSelectedImage(afrostalgiaimgs[index].image);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  const prevImage = () => {
    const newIndex = (currentIndex - 1 + afrostalgiaimgs.length) % afrostalgiaimgs.length;
    setCurrentIndex(newIndex);
    setSelectedImage(afrostalgiaimgs[newIndex].image);
  };

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % afrostalgiaimgs.length;
    setCurrentIndex(newIndex);
    setSelectedImage(afrostalgiaimgs[newIndex].image);
  };

  return (
    <>
      <h1>Afrostalgia</h1>
      <div className="gallery-images-container">
        {afrostalgiaimgs.map((afrostalgia, index) => (
          <img
            loading="lazy"
            alt="afrostalgia"
            src={afrostalgia.image}
            key={afrostalgia.id}
            onClick={() => openImage(index)}
            style={{ cursor: "pointer" }}
          />
        ))}
      </div>

      {selectedImage && (
        <div className="modal">
          <span className="close" onClick={closeImage}>&times;</span>
          <button className="prev" onClick={prevImage}>&#10094;</button>
          <img src={selectedImage} alt="Selected" className="modal-content" />
          <button className="next" onClick={nextImage}>&#10095;</button>
        </div>
      )}
    </>
  );
};

export default Afrostalgia;
